import { render, staticRenderFns } from "./instructionFolderForm.vue?vue&type=template&id=3ca41113"
import script from "./instructionFolderForm.vue?vue&type=script&lang=js"
export * from "./instructionFolderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports